export default "__VITE_ASSET__bD3yp4kz__"